import React from 'react';
import {
  TextField,
  InputAdornment,
  IconButton,
  Tooltip
} from '@mui/material';
import { MdSearch, MdClose } from 'react-icons/md';

const CrmSearchField = (props) => {
  const {
    name,
    label,
    value,
    inputProps,
    onChange,
    disabled,
    tooltip,
    helperText,
    errorMsg,
    required,
    autoComplete = 'on',
    onSearchClick, // when clicking the search icon
    onClearClick,
    moduleObj,
    relatedToRecordId,
    isEditableField,
    isFilteringMode = false
  } = props;

  const isClearAllowed = !(name==='crmNameRules')
  // const handleClear = () => {
  //   onChange?.({ target: { name, value: '' } });
  // };
  // if(value)debugger
  const textField = <TextField
    label={label}
    name={name}
    value={value}
    type='text'
    // InputLabelProps={{ shrink: true }}
    inputProps={{
      ...inputProps,
    }}
    onChange={onChange}
    fullWidth
    disabled={true}
    size="small"
    error={Boolean(errorMsg)}
    helperText={errorMsg || helperText}
    autoComplete={autoComplete}
    required={required}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end" sx={{ gap: 0.5 }}>
          {value && !disabled && (isEditableField || isFilteringMode) && isClearAllowed && (
            <IconButton
              size="small"
              onClick={onClearClick}
            >
              <MdClose />
            </IconButton>
          )}
          {(isEditableField || isFilteringMode) &&
            <IconButton
              size="small"
              onClick={() => onSearchClick(name, moduleObj, relatedToRecordId)}
              disabled={disabled}
            >
              <MdSearch />
            </IconButton>
          }
        </InputAdornment>
      ),
    }}
  />

  return tooltip ? (
    <Tooltip title={tooltip} arrow placement="top">
      {textField}
    </Tooltip>
  ) : (
    textField
  );
};

export default CrmSearchField;
